import script from "./HotList.vue?vue&type=script&setup=true&lang=js"
export * from "./HotList.vue?vue&type=script&setup=true&lang=js"

import "./HotList.vue?vue&type=style&index=0&id=72e76d17&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72e76d17"]])

export default __exports__